import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormRadioContainerPreview({ children, ...props }) {
  return <BasePreview {...props}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('form-radio-container', FormRadioContainerPreview, Fragment)
  .shared(prop.share('FormRadioContainer', 'form-radio-container'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    textAlign: {
      vertical: 'middle',
    },
  })
  .build()
